module.exports = __webpack_public_path__ + "img/ysjs.48546213.png";